/**
 * TanStack Query client configuration.
 *
 * Exported as a singleton so the same instance is shared across:
 * - QueryClientProvider in App.tsx
 * - Imperative cache operations outside React tree (e.g. SSE handlers)
 *
 * Defaults:
 * - staleTime 30s (general; hooks can override per-query)
 * - 1 retry on failure
 * - No refetchOnWindowFocus by default (hooks opt-in)
 * - gcTime 5 minutes (default)
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
